import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Stack from "@churchofjesuschrist/eden-stack";
import { grey15, spacing8 } from "@churchofjesuschrist/eden-style-constants";
const GroupContainer = styled.section.withConfig({
  componentId: "sc-1m9a6ue-0"
})(["padding:", " 0;& + &{border-block-start:1px solid ", ";}"], spacing8, grey15);

const NavigationGroup = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(GroupContainer, rest, /*#__PURE__*/React.createElement(Stack, {
    gapSize: "0"
  }, children));
};

NavigationGroup.propTypes = {
  /** Should consist of one or more `NavigationBlock*` components to render inside */
  children: PropTypes.node.isRequired
};
export default NavigationGroup;